import React from 'react';
import "./Super_admin_users_wallet.css";

export default function Superadminuserswallet() {
  return (
    <div>superadminuserswallet</div>
  )
}
